import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./CommonBoard.css";
import PageTitle from "../components/pageTitle.js";

export default function BoardNew() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const userName = sessionStorage.getItem("userName");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim() || !content.trim()) {
      alert("제목과 내용을 모두 입력해주세요.");
      return;
    }

    if (title.length > 100) {
      alert("제목은 100자 이내로 입력해주세요.");
      return;
    }

    if (content.length > 4000) {
      alert("내용은 4000자 이내로 입력해주세요.");
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${baseUrl}/api/board`, {
        title,
        content,
        userName,
      });

      alert("게시글이 등록되었습니다!");
      navigate("/services");
    } catch (err) {
      console.error("❌ 게시글 등록 실패:", err);

      if (err.response) {
        alert(`등록 실패: ${err.response.data.message || "서버 오류"}`);
      } else if (err.request) {
        alert("등록 실패: 서버로부터 응답이 없습니다.");
      } else {
        alert("등록 실패: 요청이 실패했습니다.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="board-wrapper"
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "40px 20px",
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
      }}
    >
      <div>
        <PageTitle title="치료 프로그램" />
      </div>

      <form onSubmit={handleSubmit}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <td style={{ padding: "10px", fontWeight: "bold" }}>이름</td>
            <td style={{ padding: "10px" }}>
              <span style={{ fontSize: "16px", color: "#333" }}>{userName || "알 수 없음"}</span>
            </td>
          </thead>
          <tr style={{ borderBottom: "1px solid #eee" }}></tr>
          <tbody>
            {/* 제목 */}
            <tr style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "10px", fontWeight: "bold" }}>제목<span style={{ color: "red" }}> *</span></td>
              <td style={{ padding: "10px" }}>
                <input
                  type="text"
                  placeholder="제목을 입력하세요 (최대 100자)"
                  value={title}
                  onChange={(e) => {
                    if (e.target.value.length <= 100) setTitle(e.target.value);
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "16px",
                  }}
                />
              </td>
            </tr>

            {/* 내용 */}
            <tr style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: "10px", fontWeight: "bold" }}>내용<span style={{ color: "red" }}> *</span></td>
              <td style={{ padding: "10px" }}>
                <textarea
                  placeholder="내용을 입력하세요 (최대 4000자)"
                  value={content}
                  onChange={(e) => {
                    if (e.target.value.length <= 4000) setContent(e.target.value);
                  }}
                  rows={10}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "16px",
                    resize: "vertical",
                  }}
                />
                <div style={{ textAlign: "right", fontSize: "12px", color: "#666" }}>
                  {content.length}/4000
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        {/* 등록 버튼 */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "30px", gap: "10px" }}>
          <button
            type="button"
            onClick={() => navigate("/services")}
            style={{
              padding: "10px 20px",
              backgroundColor: "#98bcc9",
              color: "white",
              borderRadius: "0px",
              fontSize: "16px",
              cursor: "pointer"
            }}
          >
            취소
          </button>
          <button
            type="submit"
            disabled={loading}
            style={{
              padding: "10px 20px",
              backgroundColor: loading ? "#ccc" : "#98bcc9",
              color: "white",
              border: "none",
              borderRadius: "0px",
              fontSize: "16px",
              cursor: loading ? "not-allowed" : "pointer"
            }}
          >
            {loading ? "등록 중..." : "등록"}
          </button>
        </div>
      </form>
    </div>
  );
}
